export default __webpack_public_path__ + "static/media/starred.94d4158f.svg";